import React, { useContext, useState } from "react";
import { GlobalContext } from "../../../Context/GlobalContext";
import SignupProgress from "../../../Components/SignupProgress";
import HeightModal from "../../../modals/HeightModal";
import WeightModal from "../../../modals/WeightModal";
import WaistModal from "../../../modals/WaistModal";
import { images } from "../../../Assets/images";

const CreateAccount2 = () => {
  const {
    signupData,
    updateSignupData,
    createAccountScreenTwo,
    translatedLabels,
    logoUrl,
  } = useContext(GlobalContext);
  const authLabel = translatedLabels?.auth;
  const [showWeightModal, setWeightModal] = useState(false);
  const [showHeightModal, setShowHeightModal] = useState(false);
  const [showWaistModal, setShowWaistModal] = useState(false);

  // Convert raw inches (slider internal) → decimal-feet string e.g. 67 → "5.7"
  const inchesToFeetDecimal = (inches) => {
    const feet = Math.floor(inches / 12);
    const inch = inches % 12;
    // Use string concat to avoid floating-point issues (e.g. 5.10 not 5.1)
    return parseFloat(`${feet}.${inch}`);
  };

  // Initialize defaults on mount if they don't exist
  React.useEffect(() => {
    const updates = {};
    if (!signupData?.height) {
      updates.height = inchesToFeetDecimal(66);
      updates.heightUnit = "feet";
    }
    if (!signupData?.weight) {
      updates.weight = 150;
      updates.weightUnit = "lbs";
    }
    if (Object.keys(updates).length > 0) {
      updateSignupData(updates);
    }
  }, []); // Run once on mount

  const handleSubmit = (e) => {
    e.preventDefault();

    // Prepare current data with any needed defaults
    const currentData = { ...signupData };

    if (!currentData.height) {
      currentData.height = inchesToFeetDecimal(66);
      currentData.heightUnit = "feet";
    }
    if (!currentData.weight) {
      currentData.weight = 150;
      currentData.weightUnit = "lbs";
    }
    if (!currentData.waistCircumference) {
      currentData.waistCircumference = 80;
      currentData.waistUnit = "cm";
    }

    // Sync with state (async)
    updateSignupData(currentData);
    // Pass immediately to context for validation (sync)
    createAccountScreenTwo(currentData);
  };

  return (
    <>
      <section id="createAccountPage" className="login-section-bg">
        <div className="container-main h-auto">
          <div className="d-flex justify-content-center">
            <div className="app-logo">
              <img
                src={logoUrl || images.appLogo}
                alt="app-logo"
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = images.appLogo;
                }}
              />
            </div>
          </div>
          <div className="content-card">
            <SignupProgress currentStep={2} />
            <h3 className="mb-4 text-center">
              {authLabel?.create_new_account?.label_value ||
                "Create new account"}
            </h3>

            <form className="login-form" onSubmit={handleSubmit}>
              <div className="mb-3">
                <label className="form-label question-label">
                  {authLabel?.what_is_your_gender?.label_value ||
                    "What is your gender?"}
                </label>{" "}
                <span className="text-danger">*</span>
                <div className="d-flex w-100 gap-3">
                  {/* Male */}
                  <div
                    className={`custom-checkbox custom-selection position-relative w-50 ${signupData?.gender === "male" ? "active-selection" : ""
                      }`}
                    onClick={() => updateSignupData("gender", "male")}
                  >
                    <div className="d-flex justify-content-between align-items-center">
                      <div className="d-flex align-items-center">
                        <div className="input-image">
                          <img src={images.maleImg} alt="male" />
                        </div>
                        <p className="mb-0 fw-semibold">
                          {authLabel?.male?.label_value || "Male"}
                        </p>
                      </div>

                      <input
                        type="radio"
                        id="maleOption"
                        name="gender"
                        value="male"
                        checked={signupData?.gender === "male"}
                        onChange={() => updateSignupData("gender", "male")}
                        hidden
                      />

                      <label
                        htmlFor="maleOption"
                        className="custom-label-left"
                      ></label>
                    </div>
                  </div>

                  {/* Female */}
                  <div
                    className={`custom-checkbox custom-selection position-relative w-50 ${signupData?.gender === "female" ? "active-selection" : ""
                      }`}
                    onClick={() => updateSignupData("gender", "female")}
                  >
                    <div className="d-flex justify-content-between align-items-center">
                      <div className="d-flex align-items-center">
                        <div className="input-image">
                          <img src={images.femaleImg} alt="female" />
                        </div>
                        <p className="mb-0 fw-semibold">
                          {authLabel?.female?.label_value || "Female"}
                        </p>
                      </div>

                      <input
                        type="radio"
                        id="femaleOption"
                        name="gender"
                        value="female"
                        checked={signupData?.gender === "female"}
                        onChange={() => updateSignupData("gender", "female")}
                        hidden
                      />

                      <label
                        htmlFor="femaleOption"
                        className="custom-label-left"
                      ></label>
                    </div>
                  </div>
                </div>
              </div>

              <div className="mb-3">
                <label className="form-label question-label">
                  {authLabel?.what_is_your_age?.label_value ||
                    "What is your age?"}
                </label>{" "}
                <span className="text-danger">*</span>
                <div className="d-flex align-items-center gap-2">
                  <div className="input-image">
                    <img src={images.age} alt="age" />
                  </div>
                  <input
                    type="number"
                    name="age"
                    className="form-control"
                    placeholder={
                      authLabel?.enter_age?.label_value || "Enter age"
                    }
                    value={signupData?.age || ""}
                    onChange={(e) => updateSignupData("age", e.target.value)}
                  />
                </div>
              </div>

              <div className="mb-3">
                <label className="form-label question-label">
                  {authLabel?.race_text?.label_value || "What is your race?"}{" "}
                  <span className="text-danger">*</span>
                </label>
                <div className="d-flex align-items-center gap-2">
                  <div className="input-image">
                    <img src={images.race} alt="race" />
                  </div>
                  <select
                    className="form-select"
                    value={signupData?.race}
                    onChange={(e) => updateSignupData("race", e.target.value)}
                  >
                    <option value="">
                      {authLabel?.select_race?.label_value || "Select Race"}
                    </option>
                    <option value="White">
                      {authLabel?.white?.label_value || "White"}
                    </option>
                    <option value="Black">
                      {authLabel?.black?.label_value || "Black"}
                    </option>
                    <option value="Asian">
                      {authLabel?.asian?.label_value || "Asian"}
                    </option>
                    <option value="Other">
                      {authLabel?.other?.label_value || "Other"}
                    </option>
                    <option value="Prefer Not To Answer">
                      {authLabel?.prefer_not_to_answer?.label_value ||
                        "Prefer Not To Answer"}
                    </option>
                  </select>
                </div>
              </div>

              <div className="form-group mb-3">
                <label className="form-label question-label">
                  {authLabel?.fourLife_weight?.label_value || "Weight"}{" "}
                  <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className="form-control wrInputText"
                  placeholder={
                    authLabel?.enter_weight?.label_value || "Enter weight"
                  }
                  value={
                    signupData.weight && signupData.weightUnit
                      ? `${signupData.weight}\u00A0\u00A0${signupData.weightUnit}`
                      : ""
                  }
                  readOnly
                  onClick={() => setWeightModal(true)}
                />
              </div>
              <div className="form-group mb-3">
                <label className="form-label question-label">
                  {authLabel?.fourLife_height?.label_value || "Height"}{" "}
                  <span className="text-danger">*</span>
                </label>
                <div className="input-group">
                  <input
                    type="text"
                    className="form-control wrInputText"
                    placeholder={
                      authLabel?.enter_height?.label_value || "Enter height"
                    }
                    value={
                      signupData.height && signupData.heightUnit
                        ? `${signupData.height}\u00A0\u00A0${signupData.heightUnit}`
                        : ""
                    }
                    readOnly
                    onClick={() => setShowHeightModal(true)}
                  />
                </div>
              </div>
              <div className="form-group mb-3">
                <label className="form-label question-label">
                  {authLabel?.waist_circumference?.label_value ||
                    "Waist Circumference"}{" "}
                  <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className="form-control wrInputText"
                  placeholder={
                    authLabel?.enter_value_in_cm?.label_value || "Enter value"
                  }
                  value={
                    signupData.waistCircumference && signupData.waistUnit
                      ? `${signupData.waistCircumference}\u00A0\u00A0${signupData.waistUnit}`
                      : ""
                  }
                  readOnly
                  onClick={() => setShowWaistModal(true)}
                />
              </div>

              <div className="">
                <div className="mb-3">
                  <label className="form-label question-label">
                    {authLabel?.do_you_smoke?.label_value || "Do you smoke?"}
                  </label>{" "}
                  <span className="text-danger">*</span>
                  <div className="d-flex align-items-center gap-2">
                    <div className="input-image">
                      <img src={images.smoke} alt="smoke" className="mb-2" />
                    </div>
                    <div className="d-flex w-100 gap-3">
                      <div
                        className={`custom-checkbox custom-selection position-relative flex-grow-1 ${signupData?.smoking === "yes"
                          ? "active-selection"
                          : ""
                          }`}
                        onClick={() => updateSignupData("smoking", "Yes")}
                      >
                        <div className="d-flex justify-content-between align-items-center">
                          <p className="m-0 fw-semibold">
                            {authLabel?.yes?.label_value || "Yes"}
                          </p>
                          <div>
                            <input
                              type="radio"
                              id="yesOption"
                              name="smoking"
                              value="Yes"
                              checked={signupData?.smoking === "Yes"}
                              onChange={() =>
                                updateSignupData("smoking", "Yes")
                              }
                              className="d-none"
                            />
                            <label
                              className="custom-label-left w-100 mb-0"
                              htmlFor="yesOption"
                            ></label>
                          </div>
                        </div>
                      </div>

                      <div
                        className={`custom-checkbox custom-selection position-relative flex-grow-1 ${signupData?.smoking === "no" ? "active-selection" : ""
                          }`}
                        onClick={() => updateSignupData("smoking", "No")}
                      >
                        <div className="d-flex justify-content-between align-items-center">
                          <p className="m-0 fw-semibold">
                            {authLabel?.no?.label_value || "No"}
                          </p>
                          <div>
                            <input
                              type="radio"
                              id="noOption"
                              name="smoking"
                              value="No"
                              checked={signupData?.smoking === "No"}
                              onChange={() => updateSignupData("smoking", "No")}
                              className="d-none"
                            />
                            <label
                              className="custom-label-left w-100 mb-0"
                              htmlFor="noOption"
                            ></label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="mb-3">
                <div className="mb-2">
                  <label className="form-label question-label mb-0">
                    {authLabel?.do_you_have_diabetes?.label_value ||
                      "Do you have diabetes?"}
                  </label>{" "}
                  <span className="text-danger">*</span>
                </div>
                <div className="d-flex align-items-center gap-2">
                  <div className="input-image">
                    <img src={images.diabetic} alt="diabetes" />
                  </div>
                  <select
                    className="form-select"
                    value={
                      signupData?.diabetes === "no"
                        ? "no"
                        : signupData?.diabetes
                          ? "yes"
                          : ""
                    }
                    onChange={(e) =>
                      updateSignupData("diabetes", e.target.value)
                    }
                  >
                    <option value="">
                      {authLabel?.select_option?.label_value || "Select Option"}
                    </option>
                    <option value="no">
                      {authLabel?.no?.label_value || "No"}
                    </option>
                    <option value="yes">
                      {authLabel?.yes?.label_value || "Yes"}
                    </option>
                  </select>
                </div>

                {signupData?.diabetes && signupData?.diabetes !== "no" && (
                  <div className="mt-3">
                    <p className="form-label question-label mb-2">
                      {authLabel?.please_select_the_type?.label_value ||
                        "Please select the type"}
                    </p>
                    <div className="d-flex gap-2">
                      {["Type 1", "Type 2", "Not sure"].map((type) => (
                        <div
                          style={{ width: "150px" }}
                          key={type}
                          className={`custom-checkbox custom-selection position-relative ${signupData?.diabetes === type ? "active-selection" : ""}`}
                          onClick={() => updateSignupData("diabetes", type)}
                        >
                          <div className="d-flex justify-content-between align-items-center">
                            <p className="m-0 small fw-semibold">{type}</p>
                            <div>
                              <input
                                type="radio"
                                id={`diabetes-${type}`}
                                name="diabetesType"
                                checked={signupData?.diabetes === type}
                                onChange={() =>
                                  updateSignupData("diabetes", type)
                                }
                                className="d-none"
                              />
                              <label
                                className="custom-label-left mb-0"
                                htmlFor={`diabetes-${type}`}
                              ></label>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>

              <div className="mb-3">
                <div className="d-flex align-items-center gap-2 mb-2">
                  <label className="form-label question-label mb-0">
                    {authLabel?.do_you_have_hypertension?.label_value ||
                      "Do you have hypertension (high blood pressure)?"}
                  </label>{" "}
                  <span className="text-danger">*</span>
                </div>
                <div className="d-flex align-items-center gap-2">
                  <div className="input-image">
                    <img src={images.bloodPressure} alt="hypertension" />
                  </div>
                  <div className="d-flex w-100 gap-3">
                    {["yes", "no"].map((option) => (
                      <div
                        key={option}
                        className={`custom-checkbox custom-selection position-relative flex-grow-1 ${signupData?.hypertension === option ? "active-selection" : ""}`}
                        onClick={() => updateSignupData("hypertension", option)}
                      >
                        <div className="d-flex justify-content-between align-items-center">
                          <p className="m-0 text-capitalize">
                            {authLabel?.[option]?.label_value || option}
                          </p>
                          <input
                            type="radio"
                            name="hypertension"
                            value={option}
                            checked={signupData?.hypertension === option}
                            onChange={() =>
                              updateSignupData("hypertension", option)
                            }
                            className="d-none"
                          />
                          <label className="custom-label-left mb-0"></label>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              <div className="mt-4 text-center">
                <button type="submit" className="btn btn-primary">
                  {authLabel?.next?.label_value || "Next"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </section>
      <WeightModal
        show={showWeightModal}
        onClose={() => setWeightModal(false)}
        initialWeight={signupData.weight}
        initialUnit={signupData.weightUnit}
        onSave={({ weight, weightUnit }) => {
          if (weightUnit === "kg") {
            if (weight < 20 || weight > 300) {
              window.showToast("error", "Weight must be between 20–300 kg.");
              return;
            }
          } else if (weightUnit === "lbs") {
            if (weight < 44 || weight > 661) {
              window.showToast("error", "Weight must be between 44–661 lbs.");
              return;
            }
          }
          updateSignupData("weight", weight);
          updateSignupData("weightUnit", weightUnit);
          setWeightModal(false);
        }}
      />
      <HeightModal
        show={showHeightModal}
        onClose={() => setShowHeightModal(false)}
        initialHeight={signupData.height}
        initialUnit={signupData.heightUnit}
        onSave={({ height, heightUnit }) => {
          if (heightUnit === "cm") {
            if (height < 100 || height > 250) {
              window.showToast("error", "Height must be between 100–250 cm.");
              return;
            }
          } else if (heightUnit === "feet") {
            if (height < 3.3 || height > 8.2) {
              window.showToast("error", "Height must be between 3.3–8.2 feet.");
              return;
            }
          }
          updateSignupData("height", height);
          updateSignupData("heightUnit", heightUnit);
          setShowHeightModal(false);
        }}
      />
      <WaistModal
        show={showWaistModal}
        onClose={() => setShowWaistModal(false)}
        initialWaist={signupData.waistCircumference}
        initialUnit={signupData.waistUnit}
        onSave={({ waist_circumference, waistUnit }) => {
          updateSignupData("waistCircumference", waist_circumference);
          updateSignupData("waistUnit", waistUnit);
          setShowWaistModal(false);
        }}
      />
    </>
  );
};

export default CreateAccount2;
